import { defaultTo } from 'lodash';
import { IModel, Model } from '.';

export interface IHospitalPrescriptionStatusModel extends IModel {
  hospitalPrescriptionStatusId: number;
  name: string;
  description: string;
  isOwnedByPetPass: boolean;
  canBeRefilledByPetPass: boolean;
  canBeRecalledByPetPass: boolean;
  canBeCancelledByPetPass: boolean;
}

export class HospitalPrescriptionStatusModel
  extends Model
  implements IHospitalPrescriptionStatusModel
{
  hospitalPrescriptionStatusId: number;
  name: string;
  description: string;
  isOwnedByPetPass: boolean;
  canBeRefilledByPetPass: boolean;
  canBeRecalledByPetPass: boolean;
  canBeCancelledByPetPass: boolean;

  constructor(params?: Partial<IHospitalPrescriptionStatusModel>) {
    super(params);
    this.hospitalPrescriptionStatusId = defaultTo(
      params?.hospitalPrescriptionStatusId,
      0,
    );
    this.name = defaultTo(params?.name, '');
    this.description = defaultTo(params?.description, '');
    this.isOwnedByPetPass = defaultTo(params?.isOwnedByPetPass, false);
    this.canBeRefilledByPetPass = defaultTo(
      params?.canBeRefilledByPetPass,
      false,
    );
    this.canBeRecalledByPetPass = defaultTo(
      params?.canBeRecalledByPetPass,
      false,
    );
    this.canBeCancelledByPetPass = defaultTo(
      params?.canBeCancelledByPetPass,
      false,
    );
  }
}
